module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "vux-datetime weui-cell",
    class: {
      'weui-cell_access': !_vm.readonly
    },
    attrs: {
      "data-cancel-text": '取消',
      "data-confirm-text": '确定',
      "href": "javascript:"
    }
  }, [_vm._t("default", function() {
    return [_c('div', [_vm._t("title", function() {
      return [_c('p', {
        class: _vm.labelClass,
        style: (_vm.styles),
        domProps: {
          "innerHTML": _vm._s(_vm.title)
        }
      })]
    }), _vm._v(" "), (_vm.inlineDesc) ? _c('inline-desc', [_vm._v(_vm._s(_vm.inlineDesc))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "weui-cell__ft vux-cell-primary vux-datetime-value",
      style: ({
        textAlign: _vm.valueTextAlign
      })
    }, [(!_vm.currentValue && _vm.placeholder) ? _c('span', {
      staticClass: "vux-cell-placeholder"
    }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), (_vm.currentValue) ? _c('span', {
      staticClass: "vux-cell-value"
    }, [_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]) : _vm._e(), _vm._v(" "), _c('icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.valid),
        expression: "!valid"
      }],
      staticClass: "vux-input-icon",
      attrs: {
        "type": "warn",
        "title": _vm.firstError
      }
    })], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0da058e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/datetime/index.vue
// module id = 333
// module chunks = 1